module.exports = function () {
    if ($(".story-section").length === 0) return;

    $('.story-slider').owlCarousel({
        items:      1,
        animateOut: 'fadeOut',
        animateIn:  'fadeIn',
        smartSpeed: 450,
        mouseDrag:  false,
        autoplay: true,
        autoplayTimeout: 5000,
        autoplayHoverPause: true
    });
    $('.image-slider').owlCarousel({
        items:      1,
        animateOut: 'fadeOut',
        animateIn:  'fadeIn',
        smartSpeed: 450,
        mouseDrag:  false,
        nav:        true,
        navText:    ['',''],
        autoplay: true,
        autoplayTimeout: 5000,
        autoplayHoverPause: true
    });

    $('.story-date button').eq(0).addClass('is-active');

    $('.story-date button').on('click', function () {
        var index = $(this).attr('data-index');
        activeDate(index);
        $('.image-slider').trigger('to.owl.carousel', [index, 400]);
        $('.story-slider').trigger('to.owl.carousel', [index, 400]);
    });
    $('.story-slider').on('changed.owl.carousel', function (event) {
        var index = event.item.index;
        activeDate(index);
        $('.image-slider').trigger('to.owl.carousel', [index, 400]);
    });
    $('.image-slider').on('changed.owl.carousel', function (event) {
        var index = event.item.index;
        activeDate(index);
        $('.story-slider').trigger('to.owl.carousel', [index, 400]);
    });
    function activeDate (i) {
        $('.story-date button').removeClass('is-active');
        $('.story-date button[data-index="'+ i +'"]').addClass('is-active');
    }
};
